import React from "react";
import { graphql } from "gatsby";
import { SecondaryNavigation } from "./SecondaryNavigation";
import { KontentRichText } from "../../../types";

interface Props {
  link_configuration__link: KontentRichText;
}

const SecondaryNavigationContainer: React.FC<Props> = (props) => {
  const links = props?.link_configuration__link;

  return <SecondaryNavigation links={links} />;
};

export default SecondaryNavigationContainer;

export const fragmentSecondaryNavigationContainer = graphql`
  fragment SecondaryNavigation on kontent_item_component___secondary_navigation {
    system {
      id
      codename
    }
    internal {
      type
    }
    elements {
      link_configuration__link {
        value
        modular_content {
          ...kontentRichTextLink
        }
      }
    }
  }
`;
